import React from 'react'

import { ChipProps } from '@mui/material/Chip'

import StyledChip from '@/components/shared/styled-chip/component'

const chipSxStyles = { height: '2.5rem', borderRadius: '100px' } as const

const FilterSheetChip = (props: ChipProps) => <StyledChip {...props} sx={{ ...chipSxStyles, ...props.sx }} />

export default FilterSheetChip
